module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./ManuallySendView.js"));
	}, "ManuallySendView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ManuallySendView!./src/pages/MessageManage/ManuallySend/ManuallySendView.js
// module id = ./node_modules/bundle-loader/index.js?lazy&name=ManuallySendView!./src/pages/MessageManage/ManuallySend/ManuallySendView.js
// module chunks = 43